import React, { Component } from 'react'

import { connect } from 'react-redux';

import {bindActionCreators} from "redux";

import _ from 'lodash';
import Firebase from 'firebase/app';
import { strings, CCAck, CCAppEventLogger, CCFlag, CCButton, colors, CCPlayerItem, Constants, DataActionTypes as DataAT, CCActions} from "./../../cc-imports";

import PropTypes from 'prop-types';
// import './DreamTeamEntryCreation.css'
import './../../styles/css/screens/DreamTeamEntryCreation/dream-team-entry-creation.css'
import CCErrorBoundary from "../../components/CCErrorBoundary/CCErrorBoundary";
const totalSalary = 10000;
const playersPerTeam =2;

class DreamTeamEntryCreation extends Component {

    static propTypes = {
        league : PropTypes.object,
        openSignIn : PropTypes.func,
        onAck : PropTypes.func
    }

    static defaultProps = {
        openSignIn : ()=>{},
        onAck : ()=>{}
    }


    constructor(props) {
        super(props)
        this.initialState = {
            teams: [],
            remainingSalaryCap: totalSalary,
            selectedPlayers: [],
            league: {},
            error : undefined,
            created : false
        }

        this.state = this.initialState;


        this.totalSalary = 10000;
        this._populatePlayers=this._populatePlayers.bind(this);
        this._playerOnLongPress=this._playerOnLongPress.bind(this);
        this._playerOnPress=this._playerOnPress.bind(this);
        this._getUpdatedSalaryCap=this._getUpdatedSalaryCap.bind(this);
        this._getDisableUpdatedTeams=this._getDisableUpdatedTeams.bind(this);
        this._showSubmit=this._showSubmit.bind(this);
        this._onSubmit=this._onSubmit.bind(this);
        this._getSelectedPlayers=this._getSelectedPlayers.bind(this);
        this._onAck=this._onAck.bind(this);
    }

    _populatePlayers(league){
        if(league) {
            const matchId = league.match.id;
            const {matchesById} = this.props;
            const match = matchesById[matchId];
            var teams = [];
            _.forEach(match.teams, (team)=> {
                team.players = _.orderBy(team.players,['salary'], ['desc']);
                _.forEach(team.players, (player)=>{ _.set(player, 'disabled',false) })
                var existingTeam = _.find(this.state.teams,{'key':team.key});
                //user playersPerTeam here to initiate
                team.selectedPlayers = [{},{}];
                teams.push(team);
            });

            this.setState({teams, selectedPlayers : [], remainingSalaryCap:totalSalary});
            // this.props.actions.removeFromCache(league.id, this.state);
        }
    }

    componentDidMount(){
        //console.log("dream team component mount")
       // console.log("dtem ----- didmount")
        const {league} = this.props
        if(league){
            const leagueCache = this.props.cache[league.id];
            if(leagueCache){
                this.setState(leagueCache);
            }
            else {
                this._populatePlayers(league);
                this.setState({league});
            }
        }
    }

    componentWillUnmount() {
        //console.log("dtem ----- unmount")
    }

    /*componentWillReceiveProps(nextProps){
        if(nextProps.league){
            const league = nextProps.league;
            this._populatePlayers(league);
            this.setState({league});
        }
    }*/

    _playerOnPress(player, selected, teamIndex){
        var teams = this.state.teams;
        var selectedPlayers = teams[teamIndex].selectedPlayers;
        _.forEach(teams[teamIndex].selectedPlayers, (selectedPlayer, index)=>{
            if(!selectedPlayer.key){
                if( !_.find(selectedPlayers,{'key':player.key}) && selected==false){
                    player.teamKey=teams[teamIndex].key;
                    selectedPlayers[index] = player;
                    return false;
                }
            }
            else {
                if(selectedPlayer.key==player.key && selected==true){
                    selectedPlayers[index] = {};
                    return false;
                }
            }
        });
        teams[teamIndex].selectedPlayers = selectedPlayers;
        selectedPlayers = this._getSelectedPlayers(teams);
        var remainingSalaryCap = this._getUpdatedSalaryCap(teams);
        teams = this._getDisableUpdatedTeams(teams, selectedPlayers, remainingSalaryCap);
        this.setState({teams, remainingSalaryCap, selectedPlayers});
    }

    _getDisableUpdatedTeams(teams, selectedPlayers, remainingSalaryCap){
        var groupResults= _.groupBy(selectedPlayers, (selectedPlayer)=>{return selectedPlayer.teamKey})

        var updatedTeams = [];
        _.forEach(teams, (team, index)=>{
            var players = [];
            _.forEach(team.players,(player)=>{
                if(groupResults[team.key] && groupResults[team.key].length==playersPerTeam){
                    player.disabled=true;
                }
                else {
                    if(remainingSalaryCap < player.salary){
                        player.disabled = true;
                    }
                    else {
                        player.disabled = false;
                    }

                    if(_.find(selectedPlayers,{key:player.key})){
                        player.disabled=true;
                    }
                }
                players.push(player);
            });
            players = _.orderBy(players,['disabled', 'salary'], [ 'asc', 'desc']);
            team.players = players;
            updatedTeams.push(team);
        });
        return updatedTeams;
    }

    _getUpdatedSalaryCap(teams){
        var salary = totalSalary;
        _.forEach(teams, (team, index)=>{
            _.forEach(team.selectedPlayers,(selectedPlayer)=>{
                if(selectedPlayer.key){
                    salary = salary-selectedPlayer.salary;
                }
            })
        });
        return salary;
    }

    _playerOnLongPress(player, selected){

    }

    _showSubmit() {
        return this.state.selectedPlayers.length==4;
    }

    _onAck() {
        this.props.actions.removeFromCache(this.props.league.id);
        this.setState(this.initialState, ()=>{
            this.props.onAck();
        });
    }

    _getSelectedPlayers(teams) {
        var selectedPlayers=[];
        _.forEach(this.state.teams,(team)=>{
            _.forEach(team.selectedPlayers,(selectedPlayer)=>{
                if(selectedPlayer.key){
                    selectedPlayers.push(selectedPlayer);
                }
            })
        });
        return selectedPlayers;
    }

    _onSubmit(){
        const {userId, user}=this.props;
        if(userId) {
            let league = this.state.league;
            CCAppEventLogger.logAppEvent('CreateEntryClicked', {
                'league_category': league.category,
                'league_type': league.type,
                'match_key': league.match.key,
                loggedIn:true,
            });

            var entry = {};
            entry.dreamTeam = this.state.selectedPlayers;
            entry.creator = user;
            entry.league = league;
            entry.coins = league.coinsPerEntry;
            Firebase.auth().currentUser.getIdToken(false).then((idToken) => {
                this.props.actions.createEntry(entry, {
                    userId: userId,
                    accessToken: idToken
                }).then(() => {
                    const {entriesType,entriesReqStatus, entriesError}=this.props;
                    //console.log("entry type after creation ---- ", entriesType, entriesReqStatus)
                    if (entriesType == DataAT.CREATE) {
                        if (entriesReqStatus==Constants.reqStatus.FAI) {
                            this.setState({error: entriesError})
                        }
                        else {
                            //console.log("-------------------- ------")
                            this.setState({...this.initialState, created: true});
                            this.props.actions.removeFromCache(this.props.league.id);
                            //this._populatePlayers(league)
                            //this.props.actions.getLeague(league.id,{accessToken:idToken}, DataAT.AUTO_REFRESH);
                            //this.props.actions.getUser({userId : this.props.user.user.id});
                        }
                    }
                })
            })
        }
        else {
            let league = this.state.league;
            if(league){
                CCAppEventLogger.logAppEvent('CreateEntryClicked', {
                    'league_category': league.category,
                    'league_type': league.type,
                    'match_key': league.match.key,
                    'entry_type': 'dream_team',
                    loggedIn:false,
                })
            }

            this.props.actions.addToCache(league.id, this.state);
            this.props.openSignIn();

        }
    }

    render() {
        const styles = ccStyle.default
        const {entriesType, entriesReqStatus} = this.props

        //console.log("dream team entry creation reached -----", entriesType, entriesReqStatus)
        return (
            <CCErrorBoundary>
            <div className="flex-container dream-team-container" >

                {
                    !this.state.created ?
                        <div  style={{flex : 1}}>
                            <div className="dreamTeamHeading">
                                <h1 className="dreamTeamHeading1" >{strings('dream_team_leagues')}</h1>
                                <h1 className="dreamTeamHeading2" style={{color:colors.theme2.font_color4}} >{strings('budget')+this.state.remainingSalaryCap}</h1>
                            </div>
                            <div className="flex-container fRow" >
                                {
                                    this.state.teams.map((team, index)=>{
                                        return (
                                            <div className="flex-container " style={{flexDirection:'column', flex:1, marginRight:2}} key={index}>
                                                <div  className="team">
                                                    <div className="flex-container team1" style={{ justifyContent:'center', alignItems:'center'}}>
                                                        <CCFlag teamKey={team.key} style={{marginRight:5}}/>
                                                        <h1 className={'dream-team-team-name'}>{team.key.toUpperCase()}</h1>
                                                    </div>
                                                    <div className="flex-container  player selected-player" style={{justifyContent:'center', marginTop:10}} >
                                                        <div className={"dreamTeamGridView"}>
                                                            {
                                                                team.selectedPlayers.map((player)=>{
                                                                    return(
                                                                        <CCPlayerItem disabled={player.key==null || player.key==undefined} index={index+1} size={styles.selectedPlayerItemSize} player={player} key={player.key}  onPress={()=>{this._playerOnPress(player , true, index)}}></CCPlayerItem>)
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={"flex-container dream-team-container-scroll"}>
                                                    <div className="dreamTeamGridView ">
                                                    {
                                                        team.players.map((player)=>{
                                                            return(<CCPlayerItem size={styles.playerItemSize} disabled={player.disabled} index={index+1} player={player} key={player.key}  onPress={()=>{ this._playerOnPress(player, false, index) }}></CCPlayerItem>)
                                                        })
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            {
                                this._showSubmit() &&
                                <div className={'dream-team-submit-btn'}>
                                    <CCButton loading={entriesType==DataAT.CREATE && entriesReqStatus==Constants.reqStatus.PEN} onPress={this._onSubmit} title={strings('submit')} style={{width:'50%', position:'absolute', left:'25%', bottom:25}}></CCButton>
                                </div>
                            }
                            {
                                this.state.error &&
                                <div className="flex-container" style={{justifyContent:'center', alignItems:'center', width:'90%', position:'absolute', left:'5%', bottom:5}}>
                                    <h1 className={'dream-team-entry-creation-error'} numberOfLines={2} style={{color : colors.theme2.font_color1}}>{this.state.error}</h1>
                                </div>
                            }
                        </div>
                        :
                        <div className="flex-container"  style={{flex:1, alignItems:'center', justifyContent:'center'}}>
                            <CCAck buttonText={strings('close')} title={strings('dream_team_leagues')} detail={strings('your_entry_created')} type={"success"} onAck={this.props.onAck}/>
                        </div>
                }
            </div>
            </CCErrorBoundary>
        )
    }
}

export default connect(state => ({
        modals: state.modals,
        matches : state.matches,

        reqStatus : state.entries.reqStatus,

        entries: state.entries,
        entriesById : state.entries.byId,
        entriesByLeague : state.entries.byLeague,
        entriesByCreatorId : state.entries.byCreatorId,
        entriesPages : state.entries.pages,
        entriesReqStatus : state.entries.reqStatus,
        entriesError : state.entries.error,
        entriesType : state.entries.type,

        user: state.user.user,
        userId: state.user ? state.user.user ? state.user.user.id : undefined : undefined,

        matchesById: state.matches.byId,

        cache: state.cache.cache
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(DreamTeamEntryCreation);


const ccStyle = {
    default:{
        playerItemSize : 'r',
        selectedPlayerItemSize : 's'
    },
    s : {
        playerItemSize : 's',
        selectedPlayerItemSize : 'xs'
    }
}



// WEBPACK FOOTER //
// ./src/app/screens/DreamTeamEntryCreation/DreamTeamEntryCreation.js